import { UserInstallationDateVm } from '../viewModel';
import { UserTimeState } from '../../../models/api-client';

export function checkInstallationDate(userTimeState: UserTimeState): UserInstallationDateVm {
  const userTimeStateVm = {} as UserInstallationDateVm;

  if (userTimeState.daysFromInstallationDate > 60) {
    userTimeStateVm.isShowHeaderText = false;
    userTimeStateVm.isShowPrioCall = true;
  } else if (userTimeState.daysFromInstallationDate <= 60 && userTimeState.daysFromInstallationDate > 14) {
    userTimeStateVm.isShowHeaderText = true;
    userTimeStateVm.isShowPrioCall = true;
  } else if (userTimeState.daysFromInstallationDate <= 14) {
    userTimeStateVm.isShowHeaderText = true;
    userTimeStateVm.isShowPrioCall = false;
  }

  return userTimeStateVm;
}
